import { createRouter, createWebHistory } from 'vue-router'  
import UserLogin from './components/UserLogin.vue'  
import MainPage from './components/MainPage.vue' 

const routes = [
    { path: '/', component: UserLogin },  
    { path: '/main', component: MainPage }, 
]

const router = createRouter({  
    history: createWebHistory(),  
    routes,  
  })  

export default router
  